// Customer form field constants
export const NAME = 'Name';
export const TYPE_ID = 'TypeId';
export const TYPE_TITLE = 'TypeTitle';
export const ADDRESS = 'Address';
export const WORK_PHONE = 'WorkPhone';
export const CELL_PHONE = 'CellPhone';
export const HOME_PHONE = 'HomePhone';
export const WORK_EMAIL = 'WorkEmail';
export const PERSONAL_EMAIL = 'PersonalEmail';
export const OTHER_EMAIL = 'OtherEmail';

// Action types
export const RESET = 'RESET';
export const CUSTOMER_CONVERT = 'CUSTOMER_CONVERT';
